import { DistributorListType, FundManager, Trustee } from './api-types';

export const GET_FUNDS_LIST = 'GET_FUNDS_LIST';
export const GET_FUNDS_LIST_SUCCESS = 'GET_FUNDS_LIST_SUCCESS';

export const ADD_FUND = 'ADD_FUND';
export const ADD_FUND_SUCCESS = 'ADD_FUND_SUCCESS';

export const ADD_PLAN = 'ADD_PLAN';
export const ADD_PLAN_SUCCESS = 'ADD_PLAN_SUCCESS';

export const UPDATE_PLAN = 'UPDATE_PLAN';
export const UPDATE_PLAN_SUCCESS = 'UPDATE_PLAN_SUCCESS';

export const GET_FUNDS_ACCESS = 'GET_FUNDS_ACCESS';
export const GET_FUNDS_ACCESS_SUCCESS = 'GET_FUNDS_ACCESS_SUCCESS';

export const UPDATE_FUND = 'UPDATE_FUND';
export const UPDATE_FUND_SUCCESS = 'UPDATE_FUND_SUCCESS';

export const GET_PLAN = 'GET_PLAN';
export const GET_PLAN_SUCCESS = 'GET_PLAN_SUCCESS';

export const GET_PLAN_DETAILS = 'GET_PLAN_DETAILS';
export const GET_PLAN_DETAILS_SUCCESS = 'GET_PLAN_DETAILS_SUCCESS';

export type GetFundsListResponseBody = {
  funds: FundProps[];
};

export type FundProps = {
  amcId: number;
  schemeCode: string;
  schemeName: string;
  amcCode: string;
  bankName: string;
  bankBranch: string;
  ifscCode: string;
  bankAccountNumber: string;
  isActive: boolean;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  plans: ClassPlanProps[];
  id: string;
  fundCategory: string;
  fundType: string;
  LEEGALITY_STAMP_SERIES: string;
  LEEGALITY_STAMP_SERIES_GROUP: string;
  LEEGALITY_STAMP_VALUE: number | null;
  LEEGALITY_USE_STAMP_SERIES: boolean | null;
  [key: string]: string | number | boolean | ClassPlanProps[] | undefined | null;
};

export type accessType = {
  fundSetupAccess: boolean;
};

export type addFundType = {
  bankAccountNumber: string;
  schemeCode: string;
  schemeName: string;
  amcCode: string;
  bankName: string;
  bankBranch: string;
  ifscCode: string;
  fundCategory: string;
  fundType: string;
  LEEGALITY_STAMP_SERIES: string;
  LEEGALITY_STAMP_SERIES_GROUP: string;
  LEEGALITY_STAMP_VALUE: number | null;
  LEEGALITY_USE_STAMP_SERIES: boolean | null;
};

export type addPlanType = {
  schemeId: number | string | null;
  planCode: string;
  planDescription: string;
  schemeNature: string;
  registrationNumber: string;
  schemeCategory: string;
  country: string;
  currency: string;
  transactionCurrency: string;
  schemeStartDate: string;
  lockInPeriod: string;
  lockInExtension: string;
  inActive: boolean;
  faceValue: number | null;
  fundAddress1: string;
  fundAddress2: string;
  fundAddress3: string;
  isActive: boolean;
  custodian: string;
  setupFee: number | null;
  fundManagerId: number | null;
  trusteeId: number | null;
  minCommitmentAmount: number | null;
  maxCommitmentAmount: number | null;
  minContributionPercentage: number | null;
  managementFee: number | null;
  performanceFee: number | null;
  performanceFeeApplicable: string;
  performanceFeeType: string | null;
  minPerformanceFee: number | null;
  maxPerformanceFee: number | null;
  placementFee: string | null;
  exitLoad: number | null;
  operatingExpenses: number | null;
  exitLoadApplicableTill: string | null;
  hurdleRate: number | null;
  tcLink: string;
  distributorIds: string[] | number[] | null;
  isApplicableForDirect: boolean;
  isoperatingExpensesApplicable: string;
  operatingExpensesType: string | null;
  operatingExpensesInWords: string | null;
  setupFeeType: string | null;
  setupFeeInWords: string | null;
  setupFeeApplicable: string | null;
  isHurdleRateTextApplicable: string | null;
  hurdleRateText: string | null;
  isAdditionalReturnTextApplicable: string | null;
  additionalReturnText: string | null;
  managementFeeApplicable: string;
  managementFeeType: string | null;
  minManagementFee: number | null;
  maxManagementFee: number | null;
  accreditedInvestorApplicable: string;
  accreditedMinCommitmentAmt: number | null;
  placementFeeApplicable: string | null;
  exitChargeApplicable: string | null;
  exitChargeType: string | null;
  defaultExitCharge: number | null;
  minExitCharge: number | null;
  maxExitCharge: number | null;
};

export type addFundPlanType = {
  schemeCode: string;
  schemeName: string;
  amcCode: string;
  bankName: string;
  bankBranch: string;
  ifscCode: string;
  bankAccountNumber: string;
  id: string;
  schemeId: number | null;
  planCode: string;
  planDescription: string;
  schemeNature: string;
  registrationNumber: string;
  schemeCategory: string;
  country: string;
  currency: string;
  transactionCurrency: string;
  schemeStartDate: string;
  lockInPeriod: string;
  lockInExtension: string;
  inActive: boolean;
  faceValue: number | null;
  fundAddress1: string;
  fundAddress2: string;
  fundAddress3: string;
  isActive: boolean;
  custodian: string;
  setupFee: number | null;
  fundManagerId: number | null;
  trusteeId: number | null;
  minCommitmentAmount: number | null;
  maxCommitmentAmount: number | null;
  minContributionPercentage: number | null;
  managementFeeApplicable: string;
  managementFeeType: string | null;
  minManagementFee: number | null;
  maxManagementFee: number | null;
  managementFee: number | null;
  performanceFee: number | null;
  performanceFeeApplicable: string;
  performanceFeeType: string | null;
  minPerformanceFee: number | null;
  maxPerformanceFee: number | null;
  placementFee: string | null;
  exitLoad: number | null;
  operatingExpenses: number | null;
  exitLoadApplicableTill: string | null;
  hurdleRate: number | null;
  tcLink: string;
  fundCategory: string;
  fundType: string;
  distributorIds: string[] | number[] | null;
  isApplicableForDirect: boolean;
  isoperatingExpensesApplicable: string;
  operatingExpensesType: string | null;
  operatingExpensesInWords: string | null;
  setupFeeType: string | null;
  setupFeeInWords: string | null;
  setupFeeApplicable: string | null;
  isHurdleRateTextApplicable: string | null;
  hurdleRateText: string | null;
  isAdditionalReturnTextApplicable: string | null;
  additionalReturnText: string | null;
  accreditedInvestorApplicable: string;
  accreditedMinCommitmentAmt: number | null;
  placementFeeApplicable: string | null;
  exitChargeApplicable: string | null;
  exitChargeType: string | null;
  defaultExitCharge: number | null;
  minExitCharge: number | null;
  maxExitCharge: number | null;
  LEEGALITY_STAMP_SERIES: string;
  LEEGALITY_STAMP_SERIES_GROUP: string;
  LEEGALITY_STAMP_VALUE: number | null;
  LEEGALITY_USE_STAMP_SERIES: boolean | null;
};

export type DistributorDetailsInPlans = {
  distributorIds: string[] | number[];
  distributors: DistributorListType[];
};
export type ClassPlanProps = {
  id: string;
  schemeId: any;
  planCode: string;
  fundManagerId: number | null;
  trusteeId: number | null;
  planDescription: string;
  schemeNature: string;
  registrationNumber: string;
  schemeCategory: string;
  country: string;
  fundManager: FundManager;
  trustee: Trustee;
  currency: string;
  transactionCurrency: string;
  schemeStartDate: string;
  lockInPeriod: string;
  lockInExtension: string;
  inActive: boolean;
  faceValue: number | null;
  fundAddress1: string;
  fundAddress2: string;
  fundAddress3: string;
  custodian: string;
  setupFee: number | null;
  minCommitmentAmount: number;
  maxCommitmentAmount: number;
  minContributionPercentage: number;
  managementFeeApplicable: string;
  managementFeeType: string | null;
  minManagementFee: number | null;
  maxManagementFee: number | null;
  managementFee: number | null;
  performanceFee: number | null;
  performanceFeeApplicable: string;
  performanceFeeType: string | null;
  minPerformanceFee: number | null;
  maxPerformanceFee: number | null;
  placementFee: string | null;
  exitLoad: number | null;
  operatingExpenses: number | null;
  exitLoadApplicableTill: string | null;
  hurdleRate: number | null;
  isActive: boolean;
  tcLink: string;
  createdBy: number | null;
  createdAt: string;
  updatedAt: string;
  distributorDetails: DistributorDetailsInPlans;
  distributorIds: string[] | number[] | null;
  isApplicableForDirect: boolean;
  isoperatingExpensesApplicable: string;
  operatingExpensesType: string | null;
  operatingExpensesInWords: string | null;
  setupFeeType: string | null;
  setupFeeInWords: string | null;
  setupFeeApplicable: string | null;
  isHurdleRateTextApplicable: string | null;
  hurdleRateText: string | null;
  isAdditionalReturnTextApplicable: string | null;
  additionalReturnText: string | null;
  // operatingExpenses: number | null;
  accreditedInvestorApplicable: string;
  accreditedMinCommitmentAmt: number | null;
  placementFeeApplicable: string | null;
  exitChargeApplicable: string | null;
  exitChargeType: string | null;
  defaultExitCharge: number | null;
  minExitCharge: number | null;
  maxExitCharge: number | null;
};

export const GET_FUNDS_SUCCESS = 'GET_FUNDS_SUCCESS';
export const GET_FUNDS = 'GET_FUNDS';

export const GET_DIRECTAPPLICABLEFUNDS_SUCCESS = 'GET_DIRECTAPPLICABLEFUNDS_SUCCESS';
export const GET_DIRECTAPPLICABLEFUNDS = 'GET_DIRECTAPPLICABLEFUNDS';
